import testConfigPreview from './testConfigPreview'

export default {
    ...testConfigPreview,
    continuousSave: false,
    autosaveRestore: false,
    disableAutoSave: true
}
